export default __webpack_public_path__ + "static/media/reims12.65192fe6.jpg";